export const ALL_LETTERS_REGEXP = /[A-Za-zА-ЯІЄЇҐа-яієїґ]/;
